import React from 'react';
import {PageEmbeddedApp} from './apps';
import {IconActionsMenu} from '../../library/cms/page-components';
import {ReactHint} from '../../library/components/components';
import { PageToolbarController } from './toolbar';
import {MediaManagerController} from '../../library/cms/media-manager';
import MediaDataManager from '../../library/cms/media-data-manager';

export class BlogSummaryItem extends React.Component{
    render(){
        return(
           <div className="page-summary">
               <div className="page-info">
                   <a className="page-summary-link" href="/Blog">
                       Blog Posts
                   </a>
               </div>
               <div>
                  <a href="/Blog">
                     <i className="material-icons">launch</i>
                  </a>
               </div>
           </div>
        );
    }
}

export class PageSummaryItem extends React.Component{
    constructor(props){
        super(props)
        this.getType=this.getType.bind(this);
    }

    getType(isEmbeddedPage){
        return (isEmbeddedPage) ? 'App' : 'User Created';
    }

    onMenuSelected(event){
        var item=event.detail.item;
        var value=item.dataset.value;
        this.props.onPageActionSelected(value,this.props.item);
    }

    render(){
        
        return(
            <div className="page-summary">
                <div className="page-info">
                    <a className="page-summary-link" href={this.props.item.permalink}>
                        {this.props.item.title}
                    </a>
                    <div>
                         <span className="light">Type: </span>
                         <span>{this.getType(this.props.item.isEmbeddedPage)}</span>
                    </div>
                    <div>
                        <span className="light">Last Updated: </span>
                        <span>{this.props.item.dateSummary}</span>
                        <span className="light"> Edited by:</span>
                        <span className="highlight">{this.props.item.editedBy}</span>
                    </div>
                </div>
                <div className="light">
                         {this.props.item.isEmbeddedPage ? (
                              <IconActionsMenu item={this.props.item} onMenuSelected={this.onMenuSelected.bind(this)} active={true}>
                                    <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="edit" data-id="edit">Edit</li>
                                    <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="settings" data-id="settings">Settings</li>
                                    <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="restore" data-id="restore">Restore</li>
                              </IconActionsMenu>
                         ):(
                            <IconActionsMenu item={this.props.item} onMenuSelected={this.onMenuSelected.bind(this)} active={true}>
                                     <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="edit" data-id="edit">Edit</li>
                                     <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="settings" data-id="settings">Settings</li>
                                     <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="restore" data-id="restore">Restore</li>
                                     <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="delete" data-id="delete">Delete</li>
                              </IconActionsMenu> 
                         )}
                </div>
            </div>
        );
    }
}

export class PagesSummary extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        var nodes = this.props.items.map((item)=> {
            return (
                <PageSummaryItem key={item.id} item={item} onPageActionSelected={this.props.onPageActionSelected} />
            );
        });

        return(
            <div className="page-summary-container">
                {this.props.enableBlog &&
                    <BlogSummaryItem />
                }
                 {nodes}
                {this.props.items.length < 1 &&
                   <div className="page-summary">
                      <div className="page-info">There are currently no pages available...</div>
                   </div>
                } 
            </div>
        );
    }
}

export class PagesSummaryApp extends PageEmbeddedApp{
   constructor(props){
       super(props);
       this.state.collection=this.props.initialData.collection;
   }

   componentDidMount() {
       super.componentDidMount();
   }

   onMediaClick(event){
       this.mediaController.mode='browse';
       this.mediaController.show();
   }

   onPageActionSelected(action,item){
       switch(action){
           case 'edit':
             location.href=item.permalink;
             break;
           case 'settings':
             this.setPageEntity(item);
             this.showSettings();
             break;
           case 'delete':
             this.deletePage(item.id);
             this.onDeletePage(item.id);
             break;  
           case 'restore':
             this.restorePage(item);
             break;
       }
   }

   onDeletePage(id){
       var pages=this.arrayDeleteItemById(this.state.collection,id);
       this.state.collection=pages;
       this.setState(this.state.collection);
   }

   handleSettings(item){
       this.setPageEntity(item);
   }

   onDashboardClick(event){
       location.href='/Admin';
   }

   onPageCreateClick(event){
       this.createPage();
   }

   render(){
       var title='Pages';
       if(this.props.title) title=this.props.title;
       var enablePageCreate=true;
       if(this.props.disablePageCreate) enablePageCreate=false;
       MediaDataManager.updateMediaUrls(this.props.initialData.media);
       return(
           <div className="relative">
              <div className="flex-box between align-center">
                <h2 className="page-summary-title">{title}</h2>
                <div className="pages-dashboard-icons">
                  <div>
                      <ReactHint events position="top" />
                      <i className="material-icons" data-rh="Media" onClick={this.onMediaClick.bind(this)}>add_a_photo</i>
                  </div>
                  {this.props.enableDashboard &&
                      <div>
                          <ReactHint events position="top" />
                          <i className="material-icons" data-rh="Dashboard" onClick={this.onDashboardClick.bind(this)}>dashboard</i>
                      </div>
                  }
                  {enablePageCreate &&
                      <div>
                          <ReactHint events position="top" />
                          <i className="material-icons" data-rh="Create" onClick={this.onPageCreateClick.bind(this)}>create</i>
                      </div>
                  }
                </div>
              </div> 
              <PagesSummary
                 items={this.state.collection} 
                 onPageActionSelected={this.onPageActionSelected.bind(this)} 
                 ref={(ref) => this.list = ref} 
                 enableBlog={this.props.enableBlog}
               />
              <PageToolbarController 
                 showToolbar={this.props.initialData.showToolbar} 
                 onCommand={this.onCommand.bind(this)} 
                 mode={this.mode} 
                 authorized={true} 
                 ref={(ref) => this.toolbarController = ref} 
                 onCreateDialogAccept={this.onCreateDialogAccept.bind(this)} 
                 onCreateDialogCancel={this.onCreateDialogCancel.bind(this)} 
                 onSettingsDialogAccept={this.onSettingsDialogAccept.bind(this)} 
                 onSettingsDialogCancel={this.onSettingsDialogCancel.bind(this)} 
                />
                <MediaManagerController
                  postUrl={this.props.initialData.mediaFilePostUrl}
                  data={this.props.initialData.media} 
                  ref={(ref) => this.mediaController = ref} 
                />
           </div>
       );
   }
}


export default PagesSummaryApp
